import { render, staticRenderFns } from "./audio-open.vue?vue&type=template&id=d324f060"
import script from "./audio-open.vue?vue&type=script&lang=js"
export * from "./audio-open.vue?vue&type=script&lang=js"
import style0 from "./audio-open.vue?vue&type=style&index=0&id=d324f060&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports